import { Tab, TabList, makeStyles, tokens } from "@fluentui/react-components";
import * as React from "react";
import { useTranslation } from "react-i18next";

// Pages
import CiTypes from "../features/citypes/components/CiTypes";
import CiRelationTypes from "../features/ciRelationTypes/components/CiRelationTypes";
import Sites from "../features/sites/components/Sites";
import Users from "../features/users/components/Users";

const useStyles = makeStyles({
  root: {
    background: tokens.colorNeutralBackground1,
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  tabContent: {
    flex: 1,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
});

function Data() {
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = React.useState(localStorage.getItem("dataTab") || "citypes");
  const styles = useStyles();

  const onTabSelect = (event, data) => {
    setSelectedValue(data.value);
  };

  return (
    <div className={styles.root}>
      <TabList
        selectedValue={selectedValue}
        onTabSelect={onTabSelect}
        style={{ marginBottom: "15px", overflowY: "hidden", flexShrink: 0 }}
      >
        <Tab value="citypes">{t("citype.types")}</Tab>
        <Tab value="cirelationtypes">CI relation types</Tab>
        <Tab value="sites">{t("generic.sites")}</Tab>
        <Tab value="users">{t("generic.users")}</Tab>
      </TabList>
      <div className={styles.tabContent}>
        {selectedValue === "citypes" && <CiTypes />}
        {selectedValue === "cirelationtypes" && <CiRelationTypes />}
        {selectedValue === "sites" && <Sites />}
        {selectedValue === "users" && <Users />}
      </div>
    </div>
  );
}

export default Data;
